import type { ButtonProps } from '@workramp/ui';
import type { EnrollTeamDrawerProps } from '../EnrollTeamDrawer';
import { Button, useDialog } from '@workramp/ui';
import WRButton from '~/components/widget/wr-button';
import { EnrollTeamDrawer } from '../EnrollTeamDrawer';

interface EnrollTeamButtonProps extends Omit<EnrollTeamDrawerProps, 'isOpen'> {
  useOldWRButton?: boolean;
  buttonProps?: ButtonProps;
}

const TRANSLATED_ENROLL_TEAM = 'Enroll Team';

export const EnrollTeamButton = ({
  academyId,
  buttonProps = {},
  trainingId,
  trainingType,
  onClose,
  showDueDate,
  useOldWRButton = false,
}: EnrollTeamButtonProps) => {
  const enrollTeamDrawer = useDialog(EnrollTeamDrawer);

  const handleEnrollTeamDrawerClose = () => {
    onClose?.();
    enrollTeamDrawer.close();
    enrollTeamDrawer.remove();
  };

  const openEnrollTeamDrawer = () =>
    enrollTeamDrawer.open({
      academyId,
      trainingType,
      trainingId,
      showDueDate,
      onClose: handleEnrollTeamDrawerClose,
    });

  if (useOldWRButton) {
    return (
      <WRButton white large className="mlm" onClick={openEnrollTeamDrawer}>
        {TRANSLATED_ENROLL_TEAM}
      </WRButton>
    );
  }

  return (
    <Button onPress={openEnrollTeamDrawer} color="secondary" variant="outline" {...buttonProps}>
      {TRANSLATED_ENROLL_TEAM}
    </Button>
  );
};
